var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hidden-lg-and-up"},[_c('v-app-bar-nav-icon',{on:{"click":_vm.clickDriwer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }